export interface DownloadOptions {
  type?: string
  fileName?: string
}

const DEFAULT_FILE_NAME = 'file'

export const download = async (content: Blob, { type, fileName }: DownloadOptions): Promise<void> =>
  await new Promise(resolve => {
    const link = document.createElement('a')
    const downloadName = fileName ?? DEFAULT_FILE_NAME

    link.href = window.URL.createObjectURL(new Blob([content], { type }))
    link.download = type ? `${downloadName}.${type}` : downloadName

    const clickHandler = (): void => {
      link.removeEventListener('click', clickHandler)
      link.remove()
      resolve()
    }

    link.addEventListener('click', clickHandler)
    link.click()
  })
